import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import './styles/TopBar.css';

function TopBar() {
  return (
    <div className="top-bar">
      <div><FontAwesomeIcon icon={faPhoneAlt} /> +91 8618173141</div>
      <div><FontAwesomeIcon icon={faEnvelope} /> info@movingbay.com</div>
    </div>
  );
}

export default TopBar;
